export const removeUnicodeCharsAndSpacesFromString = (input: string): string =>
  input.replace(/[\uE000-\uF8FF]/g, "").replace(/\s/g, "");
